import { IBookingConfirmationDomain } from "./model";

export const bookingConfirmationDomain = (state: any): IBookingConfirmationDomain => state.bookingConfirmation;
